import React from 'react';
import { ID, withCodes } from 'app/blocks/common/codes';
import { isArticlePublished } from 'app/blocks/common/products';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';
import Image from 'app/blocks/image/image';
import { isMock } from 'app/blocks/middleware/config';
import PanelActionsButtons from 'app/blocks/Panel/actions/buttons/panel_actions__buttons';
import { RevenueBadge, TypeBadge } from 'app/pages/search/_item/badges';
import ResultAttribute from 'app/pages/search/search_result__attribute';

import '../../content_search.scss';

const ResultArticle: React.VFC<{
    getContext: () => any;
    item: Search.Article;
    l: l;
}> = ({ getContext, item, l }) => {
    const bannerText = l('SEARCH_CODES.PRE_2016_BANNER', {}, '');
    const is2016BannerVisible =
        !!bannerText && !!item.doc.actions?.find(a => a?.code === 'VIEW_ON_DASHBOARD') && !item.doc.submissionId;

    function adjustActions(actions) {
        return actions.map(a => ({
            ...a,
            code: a.code === 'VIEW_ON_DASHBOARD' && is2016BannerVisible ? 'MANAGE_ARTICLE' : a.code,
        }));
    }

    let { submissionId } = item.doc;

    if (isMock()) {
        submissionId = item.id;
    }

    return (
        <div className="search_Item">
            <RevenueBadge seleniumid={item.id}>
                {l(`SEARCH_CODES.oaStatus.${item.doc.journalRevenueModel}`)}
            </RevenueBadge>

            <div className="row">
                <div className="search_Item__text col-12 col-md-8">
                    <div className="search-item__pic">
                        <Image
                            className="search_Item__img"
                            src={item.doc.journalCoverImage}
                            type={Image.TYPES.JOURNAL}
                        />
                    </div>
                    <div className="text_bold" data-seleniumid={`search-results-article-journal-name-${item.id}`}>
                        <a
                            className="search_Item_journalName"
                            dangerouslySetInnerHTML={{ __html: item.doc.journalTitle }}
                            href={item.doc.journalWolUrl}
                            rel="noopener noreferrer"
                            target="_blank"
                        />
                    </div>

                    <div
                        className="mt-two-thirds text_bold search_article_category"
                        data-seleniumid={`search-results-article-category-${item.id}`}
                    >
                        {item.doc.category}
                    </div>

                    <div className="mt-two-thirds text_bold" data-seleniumid={`search-results-article-name-${item.id}`}>
                        {isArticlePublished(item.doc) ? (
                            <a
                                dangerouslySetInnerHTML={{ __html: item.doc.title }}
                                href={item.doc.shareUrl}
                                rel="noopener noreferrer"
                                target="_blank"
                            />
                        ) : (
                            <span dangerouslySetInnerHTML={{ __html: item.doc.title }} />
                        )}
                    </div>

                    <ResultAttribute
                        className="mt-two-thirds"
                        id={item.id}
                        name={l('SEARCH_CODES.RESULT.DOI')}
                        value={item.doc.doi}
                    />

                    <ResultAttribute
                        className="mt-two-thirds"
                        id={item.id}
                        name={l('SEARCH_CODES.RESULT.REF_CODE')}
                        value={item.doc.editorialRefCode}
                    />

                    {item.doc.journalFormerTitle && (
                        <ResultAttribute
                            className="mt-two-thirds"
                            id={item.id}
                            name={l('SEARCH_CODES.RESULT.FORMER_TITLE')}
                            value={item.doc.journalFormerTitle}
                        />
                    )}
                </div>

                <div className="col-md-4 mt-base mb-base">
                    <div className="text-right">
                        {item.doc.actions && item.doc.actions.length > 0 && (
                            <>
                                <PanelActionsButtons
                                    getContext={getContext}
                                    handler={() => {}}
                                    inline={false}
                                    items={adjustActions(item.doc.actions)}
                                    name="search"
                                    params={{
                                        ARTICLE_ID: item.id,
                                        SUBMISSION_ID: submissionId,
                                    }}
                                    seleniumid={`search-results-article-${item.id}`}
                                />

                                {is2016BannerVisible && (
                                    <div className="pre-2016-banner" data-seleniumid="pre-2016-banner">
                                        <div className="pre-2016-banner-Icon">
                                            <SvgIcon.info className="InfoIcon" />
                                        </div>

                                        <div dangerouslySetInnerHTML={{ __html: bannerText }} />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <TypeBadge seleniumid={item.id}>{l('SEARCH_CODES.ARTICLE_LABEL')}</TypeBadge>
        </div>
    );
};

export default withCodes(ResultArticle, ID.SEARCH_CODES);
